import React from 'react'
import {Redirect, Route, Switch} from "react-router-dom";
import RouterPath from "../../../../libs/RouterPath";
import NotFound from "../../../NotFound/NotFound";
import PurchasingGroupStageNr from "./PurchasingGroupStageNr";
import EmailListPanel from "../../MyProcedure/scenes/emailList/EmailListPanel";


const rp = RouterPath.purchasingGroup;

function PurchasingGroupStagesRouter(
    {
        match
    }) {
    const groupId = match.params.id;

    return (
        <Switch>
            <Route path={rp.MP_PURCHASING_GROUP_GROUP_ID_STAGE_NR_SECTION} component={PurchasingGroupStageNr}/>
            <Route path={rp.MP_PURCHASING_GROUP_GROUP_ID_STAGE_NR} component={PurchasingGroupStageNr}/>
            <Route path={rp.MP_PURCHASING_GROUP_GROUP_ID_EMAIL_LIST} component={EmailListPanel}/>
            <Route exact path={rp.MP_PURCHASING_GROUP_GROUP_ID}>
                <Redirect to={groupId ? RouterPath.createPath(rp.MP_PURCHASING_GROUP_GROUP_ID_STAGE_NR, {
                    id: groupId,
                    stage: 1
                }) : RouterPath.createPath(rp.MP_PURCHASING_GROUP_LIST)} push={false}/>
            </Route>
            <Route exact path={rp.MP_PURCHASING_GROUP_GROUP_ID_STAGE}>
                <Redirect to={groupId ? RouterPath.createPath(rp.MP_PURCHASING_GROUP_GROUP_ID_STAGE_NR, {
                    id: groupId,
                    stage: 1
                }) : RouterPath.createPath(rp.MP_PURCHASING_GROUP_LIST)} push={false}/>
            </Route>
            <Route component={NotFound}/>
        </Switch>
    )
}

PurchasingGroupStagesRouter.propTypes = {}

export default PurchasingGroupStagesRouter;
	
